import { render } from "./display-card.vue?vue&type=template&id=8eed18e2&scoped=true&ts=true"
import script from "./display-card.vue?vue&type=script&lang=ts"
export * from "./display-card.vue?vue&type=script&lang=ts"

import "./display-card.vue?vue&type=style&index=0&id=8eed18e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eed18e2"]])

export default __exports__